import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface GraphNode {
  name: string;
  category?: number;
  symbolSize?: number;
}

interface GraphLink {
  source: string;
  target: string;
  value?: number;
}

interface GraphChartProps {
  nodes: GraphNode[];
  links: GraphLink[];
  categories?: Array<{ name: string }>;
  forceDirected?: boolean;
  height?: number | string;
  loading?: boolean;
}

export function GraphChart({ nodes, links, categories, forceDirected, height, loading }: GraphChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'item' },
    legend: categories ? { bottom: 0 } : undefined,
    series: [{
      type: 'graph',
      layout: forceDirected ? 'force' : 'circular',
      data: nodes,
      links,
      categories,
      roam: true,
      draggable: true,
      label: { show: true, position: 'right' },
      force: forceDirected ? { repulsion: 300, edgeLength: 120 } : undefined,
      lineStyle: { color: 'source', curveness: 0.3 },
    }],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
